module.exports = __webpack_public_path__ + "img/MatriculasAbertas-1100x350px.3677c607.png";